import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NimbusPostAdd from "./NimbusPost/NimbuspostAdd";
import Shiprocket from "./ShipRocket/ShipRocketAdd";
import Dtdc from "./DTDC/DtdcAdd";
import Delhivery from "./Delhivery/DelhiveryAdd";
import ShreeMaruti from "./ShreeMaruti/ShreeMarutiAdd";
import XpressbeesAdd from "./Xpressbees/XpressbeesAdd";
import SmartShip from "./SmartShip/SmartShipAdd";
import { toast } from "react-toastify";
import EcomExpressAdd from "./EcomExpress/EcomExpressAdd";
import AmazonAdd from "./Amazon/AmazonAdd";
import EmployeeAuthModal from "../../employeeAuth/EmployeeAuthModal";
import CustomDropdown from "./CustomDropdown"; // <-- Import custom dropdown

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const courierOptions = [
  { value: "NimbusPost", label: "NimbusPost" },
  { value: "Shiprocket", label: "Shiprocket" },
  { value: "DTDC", label: "DTDC" },
  { value: "Delhivery", label: "Delhivery" },
  { value: "ShreeMaruti", label: "ShreeMaruti" },
  { value: "Xpressbees", label: "Xpressbees" },
  { value: "SmartShip", label: "SmartShip" },
  { value: "EcomExpress", label: "EcomExpress" },
  { value: "Amazon", label: "Amazon" }
];

const AddNewCourier = ({ isSidebarAdmin }) => {
  const [selectedOption, setSelectedOption] = useState("NimbusPost");
  const [couriers, setCouriers] = useState([]);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
  const [employeeAccess, setEmployeeAccess] = useState({ canView: false, canAction: false });

  const handleCourierSaved = () => {
    setRefresh(true);
  };

  useEffect(() => {
    const fetchAccessAndCouriers = async () => {
      try {
        if (isSidebarAdmin) {
          setEmployeeAccess({ canView: true, canAction: true });
          setShowEmployeeAuthModal(false);
        } else {
          const [session, token] = document.cookie.split("=");
          const empRes = await axios.get(`${REACT_APP_BACKEND_URL}/staffRole/verify`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          const employee = empRes.data.employee;
          const canView = !!employee?.accessRights?.courier?.courier?.view;
          const canAction = !!employee?.accessRights?.courier?.courier?.action;
          setEmployeeAccess({ canView, canAction });

          if (!canView) {
            setShowEmployeeAuthModal(true);
            return;
          }
        }

        const response = await axios.get(`${REACT_APP_BACKEND_URL}/allCourier/couriers`);
        const updatedCouriers = response.data.map((courier) => ({
          ...courier,
          isActive: courier.isActive ?? true
        }));
        setCouriers(updatedCouriers);
        setRefresh(false);
      } catch (error) {
        setShowEmployeeAuthModal(true);
      }
    };

    fetchAccessAndCouriers();
  }, [refresh, isSidebarAdmin]);

  const canAction = isSidebarAdmin || employeeAccess.canAction;

  const toggleStatus = (index) => {
    setCouriers((prevCouriers) =>
      prevCouriers.map((courier, i) =>
        i === index ? { ...courier, isActive: !courier.isActive } : courier
      )
    );
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${REACT_APP_BACKEND_URL}/allCourier/deleteCourier/${id}`);
      setCouriers((prevCouriers) => prevCouriers.filter((courier) => courier._id !== id));
      toast.success("Courier deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete courier.");
    }
  };

  const existingCourierProviders = couriers.map((courier) => courier.courierProvider);
  const availableOptions = courierOptions.filter(
    (option) => !existingCourierProviders.includes(option.value)
  );

  const getInputField = () => {
    switch (selectedOption) {
      case "NimbusPost":
        return <NimbusPostAdd canAction={canAction} />;
      case "Shiprocket":
        return <Shiprocket canAction={canAction} />;
      case "DTDC":
        return <Dtdc canAction={canAction} />;
      case "Delhivery":
        return <Delhivery onCourierSaved={handleCourierSaved} canAction={canAction} />;
      case "ShreeMaruti":
        return <ShreeMaruti onCourierSaved={handleCourierSaved} canAction={canAction} />;
      case "Xpressbees":
        return <XpressbeesAdd onCourierSaved={handleCourierSaved} canAction={canAction} />;
      case "EcomExpress":
        return <EcomExpressAdd onCourierSaved={handleCourierSaved} canAction={canAction} />;
      case "Amazon":
        return <AmazonAdd onCourierSaved={handleCourierSaved} canAction={canAction} />;
      default:
        return <SmartShip canAction={canAction} />;
    }
  };

  if (!isSidebarAdmin && showEmployeeAuthModal) {
    return (
      <EmployeeAuthModal
        employeeModalShow={showEmployeeAuthModal}
        employeeModalClose={() => {
          setShowEmployeeAuthModal(false);
          window.history.back();
        }}
      />
    );
  }

  return (
    (isSidebarAdmin || employeeAccess.canView) && (
      <div className="p-2">
        <h2 className="text-[12px] md:text-[18px] text-gray-700 font-[600] mb-1">Add Courier</h2>
        <div className="mb-4">
          <CustomDropdown
            label="Select Courier"
            options={availableOptions}
            selected={selectedOption}
            onChange={setSelectedOption}
          />
          <div className="my-2">{getInputField()}</div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white shadow-md rounded-lg hidden md:table">
            <thead className="bg-[#0CBB7D] text-white">
              <tr className="text-white bg-[#0CBB7D] border border-[#0CBB7D] font-[600] text-[12px]">
                <th className="py-2 px-3 text-left">S.No</th>
                <th className="py-2 px-3 text-left">Courier Name</th>
                <th className="py-2 px-3 text-left">Courier Provider</th>
                <th className="py-2 px-3 text-left">COD Contract</th>
                <th className="py-2 px-3 text-left">Status</th>
                <th className="py-2 px-3 text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              {couriers.length > 0 ? (
                couriers.map((courier, index) => (
                  <tr key={courier._id} className="border border-gray-300 font-[400] text-gray-500 hover:bg-gray-50 transition-all text-[12px]">
                    <td className="py-2 px-3">{index + 1}</td>
                    <td className="py-2 px-3">{courier.courierName}</td>
                    <td className="py-2 px-3">{courier.courierProvider}</td>
                    <td className="py-2 px-3">{courier.CODDays}</td>
                    <td className="py-2 px-3">
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={courier.status === "Enable"}
                          onChange={() => toggleStatus(index)}
                        />
                        <div className="relative w-10 h-5 bg-[#0CBB7D] rounded-full transition-colors duration-300 peer-checked:bg-[#0CBB7D]">
                          <span
                            className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${courier.status === "Enable" ? "translate-x-5" : ""
                              }`}
                          ></span>
                        </div>
                      </label>
                    </td>

                    <td className="px-3 py-2">
                      <button
                        onClick={() => handleDelete(courier._id)}
                        className={`bg-red-500 text-white px-3 py-1 rounded-lg text-[10px] sm:text-[12px] font-[600] hover:bg-red-700 transition ${canAction ? "" : "opacity-50 cursor-not-allowed"
                          }`}
                        disabled={!canAction}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="px-4 py-2 text-center text-gray-500">
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Mobile View Table - Card Format */}
        <div className="md:hidden space-y-3">
          {couriers.length > 0 ? (
            couriers.map((courier, index) => (
              <div
                key={courier._id}
                className="bg-white rounded-lg shadow-md p-4 border border-gray-200"
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-gray-600">S.No:</span>
                  <span className="text-xs text-gray-800">{index + 1}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-gray-600">Courier Name:</span>
                  <span className="text-xs text-gray-800">{courier.courierName}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-gray-600">Provider:</span>
                  <span className="text-xs text-gray-800">{courier.courierProvider}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-gray-600">COD Days:</span>
                  <span className="text-xs text-gray-800">{courier.CODDays}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-gray-600">Status:</span>
                  <label className="inline-flex items-center cursor-pointer ml-2">
                    <input
                      type="checkbox"
                      className="sr-only"
                      checked={courier.status === "Enable"}
                      onChange={() => toggleStatus(index)}
                    />
                    <div className="relative w-10 h-5 bg-[#0CBB7D] rounded-full transition-colors duration-300 peer-checked:bg-[#0CBB7D]">
                      <span
                        className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${courier.status === "Enable" ? "translate-x-5" : ""
                          }`}
                      ></span>
                    </div>
                  </label>
                </div>
                <div className="flex justify-end mt-3">
                  <button
                    onClick={() => handleDelete(courier._id)}
                    className={`bg-red-500 text-white px-4 py-1 rounded-md text-xs font-semibold hover:bg-red-700 transition ${canAction ? "" : "opacity-50 cursor-not-allowed"
                      }`}
                    disabled={!canAction}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500 text-sm mt-4">
              No data available in table
            </div>
          )}
        </div>

      </div>
    )
  );
};

export default AddNewCourier;
